import Input from "../Input";


export const FormItems = ({fields, controls}) => fields?.length >= 1 ? fields.map((field, index) => (
    <Input {...field} {...controls} key={field?.name ? field.name : index} field={field} />
)) : null;